export default __webpack_public_path__ + "static/media/css3.54a03380.svg";